export const ENV = Object.freeze({
    LOCAL: 0,
    QA:  1,
    PROD: 2
});

export class Urls {
    static get environment() {
        if (window.location.href.includes("localhost")) {
            return ENV.LOCAL;
        } else if (window.location.href.includes('qa')) {
            return ENV.QA;
        } else {
            return ENV.PROD;
        }
    }
}